module.exports = __webpack_public_path__ + "static/media/BagguHeader-1.4357f159.JPG";